// import '@/@fake-db/db'
import Vue from 'vue'
import '@/plugins/vue-composition-api'
import { Chart, registerables } from 'chart.js'
import autocolors from 'chartjs-plugin-autocolors'
import annotationPlugin from 'chartjs-plugin-annotation'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import '@/styles/styles.scss'
import '@/styles/fonts/gotham.scss'
import '@/styles/fonts/kittithada.scss'

Chart.register(autocolors, annotationPlugin, ...registerables)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
